<template>
  <div>
    <div class="section_menu">
      <router-link to="/backoffice/parsec/account">
        <span>КПП</span>
      </router-link>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "IntegrationsAdmin",

  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
